var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCheckboxIcon = function SvgCheckboxIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 10,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M11.663 1.212a.94.94 0 0 1 0 1.326l-6.25 6.25a.937.937 0 0 1-1.326 0l-3.75-3.75a.937.937 0 1 1 1.326-1.326L4.75 6.8l5.587-5.587a.937.937 0 0 1 1.326 0",
    clipRule: "evenodd"
  })));
};
export default SvgCheckboxIcon;